module.exports = __webpack_public_path__ + "img/20.c11b5722.png";